import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { MenuComponent } from './componentes/menu/menu.component';
import { PresentacionComponent } from './componentes/presentacion/presentacion.component';
import { TransmitePracticaComponent } from './componentes/transmite-practica/transmite-practica.component';
import { ProximosEventosComponent } from './componentes/proximos-eventos/proximos-eventos.component';
import { UneteComunidadComponent } from './componentes/unete-comunidad/unete-comunidad.component';
import { InicioComponent } from './secciones/inicio/inicio.component';
import { NosotrosComponent } from './secciones/nosotros/nosotros.component';
import { NeuroakashicoComponent } from './secciones/neuroakashico/neuroakashico.component';
import { TiendaComponent } from './secciones/tienda/tienda.component';
import { DirectorioComponent } from './secciones/directorio/directorio.component';
import { CalendarioComponent } from './secciones/calendario/calendario.component';
import { RadioGaleriaComponent } from './secciones/radio-galeria/radio-galeria.component';
import { NinosComponent } from './secciones/ninos/ninos.component';
import { CongresoVirtualComponent } from './secciones/congreso-virtual/congreso-virtual.component';
import { BeneficiosComponent } from './componentes/beneficios/beneficios.component';
import { ContactoComponent } from './secciones/contacto/contacto.component';
import { IniciosObjetivoComponent } from './componentes/inicios-objetivo/inicios-objetivo.component';
import { FundadoraAnaComponent } from './componentes/fundadora-ana/fundadora-ana.component';
import { DisfrutaDeComponent } from './componentes/disfruta-de/disfruta-de.component';
import { DescargaFormacionComponent } from './componentes/descarga-formacion/descarga-formacion.component';
import { FooterComponent } from './componentes/footer/footer.component';
import { CursosComponent } from './componentes/cursos/cursos.component';
import { AprendeEnsenaComponent } from './componentes/aprende-ensena/aprende-ensena.component';
import { ProductosComponent } from './componentes/productos/productos.component';
import { FormularioPromocionesComponent } from './componentes/formulario-promociones/formulario-promociones.component';
import { EventosComponent } from './componentes/eventos/eventos.component';
import { PaginaConstruccionComponent } from './componentes/pagina-construccion/pagina-construccion.component';
import { PresentacionNinosComponent } from './componentes/presentacion-ninos/presentacion-ninos.component';
import { FormacionNinosComponent } from './componentes/formacion-ninos/formacion-ninos.component';
import { ContenidoOriginalComponent } from './componentes/contenido-original/contenido-original.component';
import { NuestroCanalComponent } from './componentes/nuestro-canal/nuestro-canal.component';
import { EstasListoComponent } from './componentes/estas-listo/estas-listo.component';
import { ContactarComponent } from './componentes/contactar/contactar.component';
import { DisfrutaBeneficiosComponent } from './componentes/disfruta-beneficios/disfruta-beneficios.component';
import { AaliComponent } from './cursos/aali/aali.component';
import { Aa2Component } from './cursos/aa2/aa2.component';
import { AacComponent } from './cursos/aac/aac.component';
import { CnComponent } from './cursos/cn/cn.component';
import { ExpComponent } from './cursos/exp/exp.component';
import { Te2020Component } from './cursos/te2020/te2020.component';
import { NagsComponent } from './cursos/nags/nags.component';
import { CaComponent } from './cursos/ca/ca.component';
import { SrnComponent } from './cursos/srn/srn.component';
import { P21esComponent } from './cursos/p21es/p21es.component';
import { NagoComponent } from './cursos/nago/nago.component';
import { DirecAapComponent } from './directorio/direc-aap/direc-aap.component';
import { DirecAalifComponent } from './directorio/direc-aalif/direc-aalif.component';
import { DirecCa2fComponent } from './directorio/direc-ca2f/direc-ca2f.component';
import { DirecCapComponent } from './directorio/direc-cap/direc-cap.component';
import { DirecCafComponent } from './directorio/direc-caf/direc-caf.component';
import { DirecCnpComponent } from './directorio/direc-cnp/direc-cnp.component';
import { DirecCnfComponent } from './directorio/direc-cnf/direc-cnf.component';
import { DirecSrnpComponent } from './directorio/direc-srnp/direc-srnp.component';
import { DirecAacpComponent } from './directorio/direc-aacp/direc-aacp.component';
import { DirecAanpComponent } from './directorio/direc-aanp/direc-aanp.component';
import { DirecAanfComponent } from './directorio/direc-aanf/direc-aanf.component';
import { TestimoniosComponent } from './componentes/testimonios/testimonios.component';
import { P21sComponent } from './cursos/p21s/p21s.component';
import { NgoComponent } from './cursos/ngo/ngo.component';

import { Aa2facilitadorComponent } from './botonespaypal/aa2facilitador/aa2facilitador.component';
import { Aa2practicanteComponent } from './botonespaypal/aa2practicante/aa2practicante.component';
import { AacpracticanteComponent } from './botonespaypal/aacpracticante/aacpracticante.component';
import { AacfacilitadorComponent } from './botonespaypal/aacfacilitador/aacfacilitador.component';
import { ExtrainfocursosComponent } from './componentes/extrainfocursos/extrainfocursos.component';
import { InfofacilitadoresComponent } from './componentes/infofacilitadores/infofacilitadores.component';
import { InfopracticantesComponent } from './componentes/infopracticantes/infopracticantes.component';
import { AalifacilitadorComponent } from './botonespaypal/aalifacilitador/aalifacilitador.component';
import { AalipracticanteComponent } from './botonespaypal/aalipracticante/aalipracticante.component';
import { CapracticanteComponent } from './botonespaypal/capracticante/capracticante.component';
import { CafacilitadorComponent } from './botonespaypal/cafacilitador/cafacilitador.component';
import { CnfacilitadorComponent } from './botonespaypal/cnfacilitador/cnfacilitador.component';
import { CnpracticanteComponent } from './botonespaypal/cnpracticante/cnpracticante.component';
import { ExppracticanteComponent } from './botonespaypal/exppracticante/exppracticante.component';
import { ExpfacilitadorComponent } from './botonespaypal/expfacilitador/expfacilitador.component';
import { NagsfacilitadorComponent } from './botonespaypal/nagsfacilitador/nagsfacilitador.component';
import { NagspracticanteComponent } from './botonespaypal/nagspracticante/nagspracticante.component';
import { SrnpracticanteComponent } from './botonespaypal/srnpracticante/srnpracticante.component';
import { SrnfacilitadorComponent } from './botonespaypal/srnfacilitador/srnfacilitador.component';
import { NgoclaseComponent } from './botonespaypal/ngoclase/ngoclase.component';
import { P21esclaseComponent } from './botonespaypal/p21esclase/p21esclase.component';
import { WhatsappComponent } from './componentes/whatsapp/whatsapp.component';
import { CicloMeditacionesComponent } from './secciones/ciclo-meditaciones/ciclo-meditaciones.component';



@NgModule({
  declarations: [
    AppComponent,
    MenuComponent,
    PresentacionComponent,
    TransmitePracticaComponent,
    ProximosEventosComponent,
    UneteComunidadComponent,
    InicioComponent,
    NosotrosComponent,
    NeuroakashicoComponent,
    TiendaComponent,
    DirectorioComponent,
    CalendarioComponent,
    RadioGaleriaComponent,
    NinosComponent,
    CongresoVirtualComponent,
    BeneficiosComponent,
    ContactoComponent,
    IniciosObjetivoComponent,
    FundadoraAnaComponent,
    DisfrutaDeComponent,
    DescargaFormacionComponent,
    FooterComponent,
    CursosComponent,
    AprendeEnsenaComponent,
    ProductosComponent,
    FormularioPromocionesComponent,
    EventosComponent,
    PaginaConstruccionComponent,
    PresentacionNinosComponent,
    FormacionNinosComponent,
    ContenidoOriginalComponent,
    NuestroCanalComponent,
    EstasListoComponent,
    ContactarComponent,
    DisfrutaBeneficiosComponent,
    AaliComponent,
    Aa2Component,
    AacComponent,
    CnComponent,
    ExpComponent,
    Te2020Component,
    NagsComponent,
    CaComponent,
    SrnComponent,
    P21esComponent,
    NagoComponent,
    DirecAapComponent,
    DirecAalifComponent,
    DirecCa2fComponent,
    DirecCapComponent,
    DirecCafComponent,
    DirecCnpComponent,
    DirecCnfComponent,
    DirecSrnpComponent,
    DirecAacpComponent,
    DirecAanpComponent,
    DirecAanfComponent,
    TestimoniosComponent,
    P21sComponent,
    NgoComponent,
   
    Aa2facilitadorComponent,
    Aa2practicanteComponent,
    AacpracticanteComponent,
    AacfacilitadorComponent,
    ExtrainfocursosComponent,
    InfofacilitadoresComponent,
    InfopracticantesComponent,
    AalifacilitadorComponent,
    AalipracticanteComponent,
    CapracticanteComponent,
    CafacilitadorComponent,
    CnfacilitadorComponent,
    CnpracticanteComponent,
    ExppracticanteComponent,
    ExpfacilitadorComponent,
    NagsfacilitadorComponent,
    NagspracticanteComponent,
    SrnpracticanteComponent,
    SrnfacilitadorComponent,
    NgoclaseComponent,
    P21esclaseComponent,
    WhatsappComponent,
    CicloMeditacionesComponent,
    
  ],
  imports: [
    BrowserModule,
    AppRoutingModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
